import api from "../../store/services/api";

export const getOrderStatsReport = (params) =>
  api.get(`/report/order/stats/`, { params });

export const getOrderByTypeFinancialReport = (params) =>
  api.get(`/report/order/total-by-type/`, { params });

export const getChannelDailySales = (params) =>
  api.get(`/report/channel-daily-sales/`, { params });

export const getMerchantDailySales = (params) =>
  api.get(`/report/merchant-daily-sales/`, { params });

const OrderStatsReportService = {
  getOrderStatsReport,
  getOrderByTypeFinancialReport,
  getChannelDailySales,
  getMerchantDailySales,
};

export default OrderStatsReportService;
